import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/constants/content";

export default function FAQ() {
  return (
    <section id="faq" className="section bg-[#F8FAFC]" data-testid="faq-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <div className="eyebrow mb-3 justify-center">Frequently Asked</div>
          <h2 className="font-display font-bold text-slate-900 text-3xl md:text-4xl lg:text-5xl tracking-tight">
            Everything you need to know.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-10 space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-slate-200/70 rounded-2xl bg-white data-[state=open]:border-[#0A84FF]/40 data-[state=open]:shadow-md transition-all px-5"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-display font-semibold text-slate-900 hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
